import { Form, Formik, FormikValues } from "formik";
import { Button, Card, Input } from "../../custom";
import styles from "./style.module.scss";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { forgotPassword } from "../../utils/auth_request";
import { validator } from "../../utils/validator";
import { routes } from "../../routes";

const validationSchema = Yup.object().shape({
  email: validator.email,
});

const ForgotPassword = () => {
  const { notification } = App.useApp();

  const forgotPasswordMutation = useMutation({
    mutationKey: ["forgot-password"],
    mutationFn: forgotPassword,
  });

  const handleForgotPassword = async (
    values: FormikValues,
    resetForm: () => void
  ) => {
    const payload: ForgotPasswordPayload = {
      email: values.email,
      isAdmin: false,
      path: "",
    };

    try {
      await forgotPasswordMutation.mutateAsync(payload, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  return (
    <section className={styles.container}>
      <div>
        <Card>
          <div className={styles.cardChild}>
            <div>
              <h3>Welcome to our portal</h3>
              <p>
                Input your email address and we'll send you reset instructions
              </p>
            </div>

            <div>
              <div>
                <Formik
                  initialValues={{
                    email: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={(values, {resetForm}) => {
                    handleForgotPassword(values, resetForm);
                  }}
                >
                  {(props) => {
                    return (
                      <Form>
                        <div className={styles.formStyle}>
                          <Input name="email" label="Email" />
                        </div>

                        <div>
                          <div>
                            <Button
                              text="SUBMIT"
                              type="submit"
                              disabled={forgotPasswordMutation?.isPending}
                              isLoading={forgotPasswordMutation?.isPending}
                            />
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            {/* <Link to="">
              <p>Forgot Password</p>
            </Link> */}
            <Link to={routes.auth.login}>
              <p>Back to Login</p>
            </Link>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default ForgotPassword;
